export default __webpack_public_path__ + "static/media/img10.4f4cddd9.svg";